import React, { useState, useRef } from 'react';
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, } from '@cargomatic/ui';
import { Pencil } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { toast } from 'react-toastify';
import { useUpdateAccountingReviewDate } from 'components/modules/orders/order-rtb/hooks/useUpdateAccountingReviewDate';
export default function AccountingReviewDate({ orderId, accountingReviewDate, }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dateValue, setDateValue] = useState('');
    const savedDateRef = useRef(undefined);
    const mutation = useUpdateAccountingReviewDate();
    const displayDate = savedDateRef.current !== undefined
        ? savedDateRef.current
        : accountingReviewDate;
    const formattedDate = displayDate
        ? format(parseISO(displayDate), 'MM/dd/yyyy')
        : 'Not Set';
    const handleOpen = (e) => {
        e.stopPropagation();
        setDateValue(displayDate ? format(parseISO(displayDate), 'yyyy-MM-dd') : '');
        setDialogOpen(true);
    };
    const handleSave = () => {
        if (!orderId)
            return;
        mutation.mutate({
            orderId,
            accountingReviewDate: dateValue
                ? new Date(`${dateValue}T00:00:00`).toISOString()
                : null,
        }, {
            onSuccess: () => {
                savedDateRef.current = dateValue
                    ? new Date(`${dateValue}T00:00:00`).toISOString()
                    : null;
                setDialogOpen(false);
                toast.success(dateValue
                    ? `Accounting review date set to ${format(new Date(`${dateValue}T00:00:00`), 'MM/dd/yyyy')}`
                    : 'Accounting review date cleared');
            },
            onError: () => {
                toast.error('Failed to update accounting review date. Please try again.');
            },
        });
    };
    const handleClear = () => {
        setDateValue('');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "flex items-center gap-1 text-sm hover:bg-muted rounded px-2 py-1", onClick: handleOpen },
            React.createElement("span", { className: "text-muted-foreground" }, "Accounting Review Date:"),
            React.createElement("span", { className: "font-medium" }, formattedDate),
            React.createElement(Pencil, { className: "h-3.5 w-3.5 text-muted-foreground" })),
        React.createElement(Dialog, { open: dialogOpen, onOpenChange: setDialogOpen },
            React.createElement(DialogContent, { className: "sm:max-w-[400px]", onClick: (e) => e.stopPropagation() },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, "Accounting Review Date"),
                    React.createElement(DialogDescription, null, "Select an accounting review date")),
                React.createElement("div", { className: "py-4" },
                    React.createElement("input", { type: "date", value: dateValue, onChange: (e) => setDateValue(e.target.value), className: "w-full px-3 py-2 border border-input rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-gray-900" })),
                React.createElement(DialogFooter, { className: "sm:justify-end gap-2" },
                    React.createElement(Button, { variant: "outline", onClick: () => setDialogOpen(false), disabled: mutation.isLoading }, "Cancel"),
                    React.createElement(Button, { variant: "outline", onClick: handleClear, disabled: mutation.isLoading }, "Clear"),
                    React.createElement(Button, { className: "bg-gray-900 text-white hover:bg-gray-800", onClick: handleSave, disabled: mutation.isLoading }, mutation.isLoading ? 'Saving...' : 'Save'))))));
}
